import { memo } from 'react';
import { useTranslation } from '../../../contexts/TranslationContext';
import { SettingsCard } from './SettingsCard';
import { DisclaimerText } from '../MHM/MHMTypography';
import { Stack } from '@mui/material';
import { MHMButton } from '../MHM/MHMButton';

export const APIDocsSettingsComponent = memo(function APIDocsSettings() {
  const { t } = useTranslation();

  return (
    <SettingsCard
      id="api_docs"
      title={t('API Docs')}
      sx={{ overflow: 'unset' }}
    >
      <Stack gap={2} p={2}>
        <DisclaimerText>
          {t(
            'For details on retrieving device data via the API, see the documentation linked below.',
          )}
        </DisclaimerText>

        <MHMButton
          href={`${import.meta.env.REACT_APP_DEVICE_API_URL}/docs/client#/Client%20Routes/get_device_data_client_device_get`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ width: 'fit-content' }}
        >
          {t('View API Documentation')}
        </MHMButton>
      </Stack>
    </SettingsCard>
  );
});
